module.exports = __webpack_public_path__ + "img/avatar5.e69f9eb0.png";